import { render, staticRenderFns } from "./ActiveDeliveryRootPage.vue?vue&type=template&id=7d94073e&scoped=true&"
import script from "./ActiveDeliveryRootPage.vue?vue&type=script&lang=js&"
export * from "./ActiveDeliveryRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d94073e",
  null
  
)

export default component.exports